import { createBrowserRouter, type RouteObject } from 'react-router';
import { CalendarScreen } from '../calendar/CalendarScreen';
import { LoginScreen } from '../auth/LoginScreen';
import { LogoutScreen } from '../auth/LogoutScreen';
import { RecoveryCodesScreen } from '../auth/RecoveryCodesScreen';
import { RequireOwner } from '../auth/RequireOwner';
import { TwoFactorConfigureScreen } from '../auth/TwoFactorConfigureScreen';
import { TwoFactorVerifyScreen } from '../auth/TwoFactorVerifyScreen';
import { OwnerLayout } from './OwnerLayout';

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginScreen /> },
  { path: '/login/two-factor/configure', element: <TwoFactorConfigureScreen /> },
  { path: '/login/two-factor/verify', element: <TwoFactorVerifyScreen /> },
  { path: '/login/two-factor/recovery-codes', element: <RecoveryCodesScreen /> },
  { path: '/logout', element: <LogoutScreen /> },
  {
    path: '/',
    element: (
      <RequireOwner>
        <OwnerLayout />
      </RequireOwner>
    ),
    children: [{ index: true, element: <CalendarScreen /> }]
  }
];

export const createAppRouter = (): ReturnType<typeof createBrowserRouter> =>
  createBrowserRouter(routes);
